import { configurePlatform } from '@fieldvision/core';
import { webPlatform } from './platform.web.js';
/**
 * The browser entry point to `@fieldvision/core`.
 *
 * WHAT THIS PACKAGE IS NOW. Everything that used to live here moved to
 * `@fieldvision/core` when a third client — the React Native staff app —
 * appeared and could not import a package that assumes `sessionStorage`,
 * `navigator.geolocation` and a cookie jar. What is left is the browser half:
 * the platform adapter, and the one API call that genuinely needs a `Blob`.
 *
 * Both web applications keep importing `@fieldvision/web-core` and none of their
 * call sites changed. That is deliberate: there are 38 of them across two apps,
 * and a rename would have been 38 files of churn in a commit whose whole value
 * is that it changes no behaviour.
 *
 * THE IMPORT SIDE EFFECT BELOW IS LOAD-BEARING. Configuring the platform here,
 * rather than asking each app to do it in `main.tsx`, is what makes the move
 * invisible to callers — and it is safe only because the auth store defers
 * hydration (`skipHydration`, see `auth.store.ts`), so importing it touches no
 * storage. The alternative was editing two entrypoints and trusting that nobody
 * ever adds a 39th import that runs first.
 */
configurePlatform(webPlatform);
export { configureApiBase, getApiBase, ApiError, NO_RESPONSE, retryPolicy, retryDelay, loginErrorMessage, totpErrorMessage, apiErrorMessage, apiIssues, buildQuery, withQuery, useAuth, useSessionBootstrap, useAccessScope, can, canAll, canAny, currentPosition, idempotencyKey, formatDistance, formatRupiah, isImplausiblePrice, IMPLAUSIBLE_PRICE_FLOOR_IDR, useDebouncedValue, containRect, boxRect, clampScale, clampPan, zoomAbout, MIN_SCALE, MAX_SCALE, useVisitSession, activeVisitQuery, useActiveVisit, invalidateActiveVisit, configureUploadQueue, enqueue, pending, remove, drain, startAutoDrain, sweepOrphans, stage, pendingFor, previewOf, discardDraft, discardAllFor, commitStaged, useVisitDrafts, } from '@fieldvision/core';
/** `api` is core's, plus the browser-only `uploadToStorage`. */
export { api } from './api.js';
//# sourceMappingURL=index.js.map